/**
 * Decimal Field Default Configuration
 *
 * Numeric input field for decimal numbers with precision control.
 * Properties aligned with API JSON configuration structure.
 */

export interface DecimalFieldConfig {
  label: string;
  showTitle: boolean;
  exclusionType: 'hide' | 'disable';
  displayName: string;
  shortDisplayName?: string;
  required: boolean;
  value: number;
  decimalPlaces: number;
}

export const DECIMAL_DEFAULT_CONFIG: Omit<DecimalFieldConfig, 'label' | 'displayName'> = {
  showTitle: true,
  exclusionType: 'hide',
  shortDisplayName: '',
  required: false,
  value: 0,
  decimalPlaces: 2,
};

/**
 * Create default configuration for a decimal field
 * @param fieldName The field name to use as label
 */
export const createDecimalConfig = (fieldName: string): DecimalFieldConfig => ({
  ...DECIMAL_DEFAULT_CONFIG,
  label: fieldName,
  displayName: '',
});

export default createDecimalConfig;
